import Vue from 'vue'
import {
  Button,
  Header,
  Container,
  Menu,
  MenuItem,
  Aside,
  Main,
  Footer,
  Message,
  MessageBox,
  Table,
  TableColumn,
  Pagination,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  Submenu,
  Form,
  FormItem,
  Input,
  DatePicker,
  OptionGroup,
  Option,
  Select,
  Dialog,
  Checkbox,
  Collapse,
  CollapseItem,
  Upload,
  Popover
} from 'element-ui'
Vue.use(Popover)
Vue.use(Upload)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Submenu)
Vue.use(DropdownItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Pagination)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Header)
Vue.use(Container)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
